import { addHydrationListener } from "../../hydration";
export const FORM_SUBMIT_DELAY_MS = 150;
/**
 * Adds a managed submit listener to a form.
 *
 * @param form
 * @param listener
 * @param order
 * Can be positive, negative, 0, or undefined.
 * Lower ordered listeners run first.
 * Listeners with an undefined order run last, just before finalizing submit.
 * Same ordered listeners run in the order they are added.
 * Form validation, when applicable, runs after negative order and just before 0 order listeners.
 */
export function addSubmitListener(form, listener, order) {
    const f = form;
    if (f.submitListeners === undefined) {
        f.submitListeners = [{ listener, order }];
    }
    else {
        f.submitListeners.push({ listener, order });
    }
}
export function initForm() {
    whenReady(() => {
        const forms = document.querySelectorAll("main form");
        forms.forEach((form) => {
            form.addEventListener("submit", handleFormSubmit);
            form.addEventListener("prismPress", handleSecondarySubmitButtonClick);
            form.addEventListener("prismClick", handleSecondarySubmitButtonClick);
        });
    });
}
function whenReady(callback) {
    const prismLayout = document.querySelector("prism-layout");
    if (prismLayout) {
        addHydrationListener(prismLayout, callback);
    }
    else {
        callback();
    }
}
function handleFormSubmit(event) {
    var _a;
    const form = event.target;
    const orderedListeners = ((_a = form.submitListeners) !== null && _a !== void 0 ? _a : []).sort(compareOrderedSubmitListeners);
    const postValidationFoundIndex = orderedListeners.findIndex((orderedListener) => { var _a; return ((_a = orderedListener.order) !== null && _a !== void 0 ? _a : 0) >= 0; });
    const postValidationIndex = postValidationFoundIndex === -1 ? 0 : postValidationFoundIndex;
    const preValidationListeners = orderedListeners.slice(0, postValidationIndex);
    const postValidationListeners = orderedListeners.slice(postValidationIndex);
    preValidationListeners.forEach(getRunSubmitListener(event));
    checkFormValidity(event);
    postValidationListeners.forEach(getRunSubmitListener(event));
    finalizeSubmit(event);
}
function compareOrderedSubmitListeners(a, b) {
    return a.order === undefined
        ? b.order === undefined
            ? 0
            : 1
        : b.order === undefined
            ? -1
            : a.order - b.order;
}
function getRunSubmitListener(event) {
    return (orderedListener) => orderedListener.listener(event);
}
function checkFormValidity(event) {
    const form = event.target;
    if (!event.defaultPrevented &&
        (form.isSubmitting || (isValidationEnabled(event) && !form.checkValidity()))) {
        event.preventDefault();
    }
}
function isValidationEnabled(event) {
    var _a;
    return !((_a = event.submitter) === null || _a === void 0 ? void 0 : _a.hasAttribute("formnovalidate"));
}
function finalizeSubmit(event) {
    if (!event.defaultPrevented) {
        const form = event.target;
        form.isSubmitting = true;
        if (showLoaderOnSubmitterComponentIfNeeded(event)) {
            delayFormSubmitToStartLoaderAnimationSafari(event);
        }
    }
}
function showLoaderOnSubmitterComponentIfNeeded(event) {
    var _a;
    const component = (_a = event.submitter) === null || _a === void 0 ? void 0 : _a.closest("prism-button");
    if (component && component.getAttribute("display") !== "link") {
        component.setAttribute("loading", "true");
        return true;
    }
    return false;
}
function delayFormSubmitToStartLoaderAnimationSafari(event) {
    const form = event.target;
    event.preventDefault();
    setTimeout(() => {
        appendHiddenInputButtonData(form, event.submitter);
        form.submit();
    }, FORM_SUBMIT_DELAY_MS);
}
function appendHiddenInputButtonData(form, button) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = button.name;
    input.value = button.value;
    form.appendChild(input);
}
function handleSecondarySubmitButtonClick(event) {
    const form = event.target.closest("form");
    const button = event.detail.target;
    if (form &&
        !form.isSubmitting &&
        isHTMLButton(button) &&
        isSecondarySubmitButton(button)) {
        form.isSubmitting = true;
        appendHiddenInputButtonData(form, button);
        form.submit();
    }
}
function isHTMLButton(value) {
    return value instanceof HTMLButtonElement;
}
function isSecondarySubmitButton(element) {
    return element.name === "_eventId" && element.type === "button";
}
